var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { Level } from '@/models/Level';
import DataTable from '@/components/data-table/DataTable';
import PageHeader from '@/components/page-header/PageHeader';
import AddLevelDialog from '@/views/Levels/AddLevelDialog';
import ErrorHandler from '@/support/ErrorHandler';
let Levels = class Levels extends Vue {
    constructor() {
        super(...arguments);
        this.$pageTitle = 'Levels';
        this.selected = [];
        this.isCreatingLevel = false;
        this.selectedLevel = null;
    }
    get tableOptions() {
        return {
            name: {
                singular: this.$tc('level.title', 1),
                plural: this.$tc('level.title', 2),
            },
            headers: [
                {
                    text: this.$t('name.title'),
                    value: 'name',
                    // action: '/levels/{id}',
                    editable: true,
                    changed: false,
                },
                {
                    text: this.$t('value.title'),
                    value: 'value',
                    editable: true,
                    changed: false,
                },
                {
                    text: this.$t('sequence.title'),
                    value: 'sequence',
                    editable: true,
                    changed: false,
                    sortable: {
                        key: 'sequence',
                        order: 'ASC',
                    },
                },
            ],
            actions: [
                // {
                //   type: 'view',
                //   label: 'view',
                //   icon: 'remove_red_eye',
                //   action: '/levels/{id}',
                // },
                {
                    type: 'delete',
                    label: 'delete',
                    icon: 'delete',
                    action: (vm, level) => {
                        this.selectedLevel = level;
                        this.$store.dispatch('openDialog', this.dialogOptions);
                    },
                },
            ],
            filters: [],
            model: new Level(),
        };
    }
    get dialogOptions() {
        const level = this.selectedLevel;
        return {
            title: level.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.level') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!level) {
                            return;
                        }
                        level
                            .delete()
                            .then((response) => {
                            if (response) {
                                this.selectedLevel = null;
                                this.refreshDataTable();
                            }
                        })
                            .catch((error) => {
                            ErrorHandler.network(error);
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedLevel = null;
                    },
                },
            },
        };
    }
    refreshFilterStore() {
        new Level()
            .all()
            .then((levels) => {
            const mutatedLevels = [];
            const payload = {};
            levels.forEach((level) => {
                mutatedLevels.push({
                    value: level.id,
                    text: level.getFilterLabel(),
                });
            });
            payload.Level = mutatedLevels;
            this.$store.dispatch('updateFilters', payload);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    refreshDataTable() {
        this.refreshFilterStore();
        document.dispatchEvent(new CustomEvent('datatable:hook', {
            detail: (dataTable) => {
                dataTable.refresh();
            },
        }));
    }
};
Levels = __decorate([
    Component({
        components: {
            DataTable,
            PageHeader,
            AddLevelDialog,
        },
    })
], Levels);
export default Levels;
